<template>
  <div class="box11">
    <pageTitle
      title="大厂经验师资教学&nbsp;&nbsp;接轨企业主流技术"
      text="严选互联网技术大牛，领跑业内教研水平，进一步保障课程质量"
      titleColor="#FFFFFF"
      titColor="#FFFFFF"
    />

    <div class="top-box">
      <div class="block">
        <div class="top">
          <i>高学历</i>
          <b></b>
        </div>
        <div class="bottom">
          博士、硕士</br>研究生、985
        </div>
      </div>
      <div class="block">
        <div class="top">
          <i>大厂背景</i>
          <b></b>
        </div>
        <div class="bottom">
          京东、华为、</br>腾讯...
        </div>
      </div>
      <div class="block">
        <div class="top">
          <i>资历深厚</i>
          <b></b>
        </div>
        <div class="bottom">
          技术和授课</br>经验10年+
        </div>
      </div>
    </div>

    <div class="teacher-box">
      <div
        class="teacher"
        v-for="(item, index) in list"
        :key="index"
        :style="
          `backgroundImage: url(` +
          require(`../../../assets/coursePage/softwareTest/box10/${
            index + 1
          }.png`) +
          `)`
        "
        @click="changeCur(index)"
      >
        <div class="tName">{{ item.name }}老师</div>
          <div class="tagList">
            <p>
              <span v-for="(item2, index2) in item.tag" :key="index2"
                >{{ item2 }}
                <span v-show="index2 != item.tag.length - 1">| </span>
              </span>
            </p>
          </div>
      </div>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      round
      :style="{ height: '8.973333rem' }"
    >
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ list[this.cur].name }}老师</div>

          <div class="close" @click="show = false"></div>
        </div>

        <div class="tag-box">
          <div
            class="tag"
            v-for="(item, index) in list[this.cur].tag"
            :key="index"
            :class="'tag' + (index + 1)"
          >
            {{ item }}
          </div>
        </div>

        <p
          v-for="(j, index1) in list[cur].info"
          :key="index1"
          :class="{ word: cur == 2 && index1 == 0 }"
        >
          <span></span>
          {{ j }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      list: [
        {
          name: "许",

          tag: [
            "10年+软件测试开发经验",
          ],
          info: [
            "10年以上软件测试开发、质量管理、项目管理经验；",
            "丰富的质量管理、项目管理与产品管理经验；",
            "熟练使用Java、Python开发语言，擅长功能测试、接口测试、自动化测试、性能测试等；",
            "具有丰富的教学经验，授课幽默风趣，能积极调动学员的积极性；",
          ],
        },
        {
          name: "朱",
          tag: [
            "8年软件测试及项目管理经验",
          ],
          info: [
            "曾先后在不同互联网企业担任高级软件测试工程师、测试主管等职务；",
            "参与测试的项目有网络安全类、互联网出行类、电子商务类项目，擅长功能测试、接口测试及自动化测试；",
            "具有国家信息系统项目管理师认证、ACP认证；",
          ],
        },
      ],
    };
  },
  methods: {
    changeCur(index) {
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box11 {
  padding: 80px 0;
  padding-bottom: 50px;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box10/bg2.png")
    no-repeat;
  background-size: cover;

  .word {
    white-space: nowrap;
  }

  .top-box {
    margin: 48px 32px 60px;

    padding: 24px 0 20px;
    background: #ffffff;
    box-shadow: 0px 8px 24px 0px rgba(12, 158, 123, 0.08);
    border-radius: 16px;
        display: flex;
    justify-content: center;
        align-items: center;
    .block {
      margin-right: 76px;
      .top {
        margin-bottom: 8px;
        text-align: center;
        position: relative;
        i {
          font-size: 28px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #3a81ff;
          line-height: 44px;
          text-align: center;
          position: relative;
          z-index: 2;
        }
        b {
          position: absolute;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
          display: block;
          width: 84px;
          height: 12px;
          background: #e0ecff;
        }
      }
      .bottom {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        text-align: center;
      }
    }
    .block:last-child {
      margin-right: 0;
    }
    p {
      margin-bottom: 8px;
      font-size: 32px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: #2ea5fc;
      line-height: 48px;
    }
  }

  .teacher-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 32px;

    .teacher {
      margin-bottom: 28px;
      padding: 0 24px 20px;
      width: 328px;
      height: 424px;

      background-size: cover;
      background-repeat: no-repeat;
      box-sizing: border-box;
      color: #fff;
      .tName {
        margin-top: 318px;
        margin-bottom: 8px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      p {
        margin-top: 8px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        b {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          i {
            display: inline-block;
            margin: 0 6px 4px 2px;
            position: relative;
            top: -3px;
          }
        }
      }
    }
  }

  .pop {
    padding: 40px 46px;
    padding-bottom: 80px;
    height: 628px;
    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .title {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 32px;
    }

    .tag {
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 0px 16px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      background: #e8f3ff;
      border-radius: 8px;

      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #165dff;
    }

    // .tag2 {
    //   height: 44px;
    //   background: #fff7e8;
    //   border-radius: 8px;

    //   color: #ff7d00;
    // }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;
      padding-left: 24px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      span {
        position: absolute;
        top: 16px;
        left: 0px;
        margin-right: 16px;
        min-width: 8px;
        height: 8px;
        background: #becfff;
        border-radius: 50%;
      }
    }
  }
}
</style>
